import Phaser from 'phaser';
import { WALL_FRAME } from '../tileFrames';
import { TILE } from '../balance';

export default class Wall extends Phaser.Physics.Arcade.Image {
  constructor(scene: Phaser.Scene, x: number, y: number, key: string) {
    // 使用 tileset spritesheet 中的墙体帧（带顶部高光面，素材 16×16）
    super(scene, x, y, 'tileset', WALL_FRAME);
    scene.add.existing(this);
    scene.physics.add.existing(this, true);
    this.setOrigin(0.5, 0.5);
    // 贴图放大到一整格（32px）
    this.setDisplaySize(TILE, TILE);
    // 关键：静态体不会随 setDisplaySize 更新，必须显式同步，
    // 否则碰撞盒仍是素材原始 16×16（小于视觉）→ 玩家会「穿墙」。
    (this.body as Phaser.Physics.Arcade.StaticBody).updateFromGameObject();
    this.setImmovable(true);
  }
}
